import { apiClient, API_ENDPOINTS } from '@/shared/apiClient';
import type { ClassificationSource, DevelopmentRole, VisibilityTier, Workstream } from '@/shared/types/projectData';

export interface SuggestNodeMetadataRequest {
  nodeType: 'group' | 'task' | 'milestone' | 'document' | 'report' | 'checklist';
  title?: string;
  description?: string;
  contentExcerpt?: string;
  parentId?: string | null;
}

export interface NodeMetadataSuggestion {
  workstream: Workstream;
  development_roles: DevelopmentRole[];
  visibility_tier: VisibilityTier;
  classification_source: ClassificationSource;
  classification_confidence: number | null;
  rationale: string;
  provider: string;
  parent_visibility_tier?: VisibilityTier | null;
}

interface SuggestNodeMetadataResponse {
  success: boolean;
  data?: {
    suggestion?: NodeMetadataSuggestion;
  };
}

export const nodeMetadataService = {
  async suggest(projectId: string, request: SuggestNodeMetadataRequest): Promise<NodeMetadataSuggestion> {
    const response = await apiClient.post<SuggestNodeMetadataResponse>(
      API_ENDPOINTS.projects.metadataSuggest(projectId),
      {
        node_type: request.nodeType,
        title: request.title || '',
        description: request.description || '',
        content_excerpt: request.contentExcerpt || '',
        parent_id: request.parentId || null,
      },
      'metadata'
    );

    if (!response.data?.suggestion) {
      throw new Error('Metadata suggestion payload missing');
    }
    return response.data.suggestion;
  },
};
